<template>
  <div class="home">
    <audio
      src="@/assets/audio/1.mp3"
      loop
      preload="auto"
      id="firstAudio"
    ></audio>
    <div class="video">
      <video
        style="width: 100%; object-fit: contain"
        autoplay="autoplay"
        muted="true"
        poster="@/assets/video/bg.png"
        tabindex="-1"
        loop="loop"
        playsinline="true"
        preload="auto"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        id="firstvideo"
        :style="{visibility:(videocanautoplay?'visible':'hidden')}"
      > 
        <source src="@/assets/video/1.mp4" type="video/mp4" />
        <source src="@/assets/video/1.mp4" type="video/ogg" />
        <source src="@/assets/video/1.mp4" type="video/webm" />
      </video>
      <!-- <img
        src="@/assets/video/video-btn.png"
        class="videoBtn phoneshow"
        v-if="!videocanautoplay"
        @click="videoPlay"
      /> -->
    </div>
    <div class="words_div">
      <div class="top_nav">
        <div class="top_nav_cont">
          <!-- <a href="javascript:void:(0);">
            <img src="@/assets/images/logo.png" />
          </a> -->
          <div class="playBtn" @click="tabPlay">
            <img src="@/assets/images/music-pause.png" v-if="!audioplay" />
            <img
              src="@/assets/images/music-play.png"
              class="canplay"
              v-if="audioplay"
            />
          </div>
        </div>
      </div>
      <div class="centermiddle_div">
        <img
        src="@/assets/video/bg.png" class="video-bg"
        v-if="!videocanautoplay"
      />
        <div class="main_part">
          <img
            src="@/assets/images/IC1101_banner_ynw.png"
            class="banner_logo"
          />
        </div>
        <div class="link_part flex">
           <a
            href="https://distrikt.app/u/IC1101World"
            target="_blank"
            class="twitter_a"
          >
            <img src="@/assets/images/distrikt.png" />
          </a>
          <a
            href="https://twitter.com/IC1101World"
            target="_blank"
            class="twitter_a"
          >
            <img src="@/assets/images/twitter.png" />
          </a>
        </div>
        <div class="flex flexcenter foot_div pcshow">
          <img src="@/assets/images/pw.svg" class="pw_img" />
          <!-- <p class="copyright_p">© 1790 - 2022 Herschel Interactive Limited</p> -->
        </div>
      </div>
      <div class="flex flexcenter foot_div phoneshow">
        <img src="@/assets/images/pw.svg" class="pw_img" />
        <!-- <p class="copyright_p">© 1790 - 2022 Herschel Interactive Limited</p> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /srcf-nav-icon1
export default {
  name: "Home",
  components: {},
  data() {
    return {
      videocanautoplay: false,
      audioplay: false,
    };
  },
  methods: {
    // videoPlay() {
    //   let video = document.getElementById("firstvideo");
    //   video.play();
    //   this.videocanautoplay = true;
    // },
    tabPlay() {
      this.audioplay = !this.audioplay;
      if (this.audioplay) {
        document.getElementById("firstAudio").volume = 0.2;
        document.getElementById("firstAudio").play();
      } else {
        document.getElementById("firstAudio").pause();
      }
    },
  },
  beforeDestroy() {},
  mounted() {
    let $this = this;
    let video = document.getElementById("firstvideo");
    let t = setInterval(() => {
      if (video.currentTime > 0) {
        this.videocanautoplay = true
        clearInterval(t);
      }
    }, 100);
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  height: 100vh;
  max-height: 100vh;
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
}
.flex {
  display: flex;
}
.flexcenter {
  align-items: center;
  justify-content: center;
}
.phoneshow {
  display: none;
}
.top_nav {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0.17);
}
.top_nav_cont {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.playBtn {
  width: 36px;
  height: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.playBtn img {
  width: 30px;
}
.videoBtn {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  margin-top: -30px;
  margin-left: -30px;
  cursor: pointer;
  z-index: 99999;
}
.video,
.words_div {
  width: 100%;
  height: 100%;
  max-width: 1920px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.words_div {
  position: absolute;
  top: 0;
  left: 0;
}
.centermiddle_div {
  width: 100vw;
  height: 56.25vw;
  position: absolute;
  max-height: 100vh;
}
// main
.main_part {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.banner_logo {
  width: 40%;
  margin: 0 auto 5vw;
  max-width: 520px;
}
.link_part {
  position: absolute;
  top: 70%;
  left: 50%;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -100px;
}
.twitter_a {
  display: block;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.twitter_a:hover {
  background: rgba(255, 255, 255, 0.5);
}

.foot_div {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-bottom: 10px;
}
.copyright_p {
  font-size: 16px;
  font-family: "SFProText-Medium, SFProText";
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  line-height: 16px;
}
.pw_img {
  width: 50%;
  max-width: 520px;
}
.video-bg{width: 100%;height: 100%;}
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.canplay {
  animation: turn 3s linear infinite;
}
@media screen and (max-width: 950px) {
  .pcshow {
    display: none;
  }
  .phoneshow {
    display: block;
    display: flex;
  }
  .copyright_p {
    font-size: 14px;
  }
  .banner_logo {
    width: 38%;
    max-width: 320px;
  }
  .twitter_a {
    width: 50px;
    height: 50px;
  }
  .twitter_a img {
    max-width: 25px;
  }
  .flex.foot_div {
    flex-direction: column;
  }
  .copyright_p {
    padding-bottom: 15px;
  }
}
@media screen and (max-width: 750px) {
  .copyright_p {
    font-size: 12px;
  }
  .banner_logo {
    max-width: 300px;
  }
}
@media screen and (max-width: 650px) {
  .link_part {
    width: 140px;
    margin-left: -70px;
  }
  .pw_img {
    width: 100%;
    max-width: 300px;
  }
  .twitter_a {
    width: 42px;
    height: 42px;
  }
  .twitter_a img {
    width: 20px;
  }
}
</style>
